import { useTranslation } from "react-i18next";
import styled from "styled-components";

import {
  Artifact,
  ArtifactProjectType,
  ArtifactProjectTypeLabel,
  LutronDesignerMessageType,
} from "../../models";
import dateFormat from "../../utils/date";
import ArtifactKebabMenu from "../ArtifactKebabMenu/ArtifactKebabMenu";
import { useToolContext } from "../ToolContext/ToolContext";

import ProductTypeBadges from "./ProductTypeBadges";
import { ActionButton, TableCell, TableRow } from "./TableStyle";

const DesignTableRow = styled(TableRow)`
  background: rgba(0, 0, 0, 0.04);
  padding: 10px 0px;

  &:hover {
    background: rgba(0, 0, 0, 0.08);
  }

  &:hover ${ActionButton} {
    visibility: visible;
  }
`;

const ProductType = styled.span`
  padding: 0px 10px;
`;

export const DesignTableCell = styled(TableCell)`
  align-items: center;
`;

type Props = {
  artifact: Artifact;
  onClick: () => void;
};

const DesignRow = ({ artifact, onClick }: Props): JSX.Element => {
  const { t } = useTranslation();
  const context = useToolContext();

  return (
    <DesignTableRow data-testid="artifact-row">
      <DesignTableCell />
      <DesignTableCell>
        <ProductTypeBadges artifacts={[artifact]} />
        <ProductType>
          {artifact.artifactProjectType !== null
            ? ArtifactProjectTypeLabel[artifact.artifactProjectType] || "-"
            : "-"}
        </ProductType>
      </DesignTableCell>
      <DesignTableCell>
        <>
          <ActionButton
            data-testid={`artifact-open-btn[${artifact.id}]`}
            onClick={onClick}
          >
            {t("table.actions.download_artifact")}
          </ActionButton>
          {(context.capabilities?.includes(
            LutronDesignerMessageType.OpenVersionRequest,
          ) ||
            (artifact.artifactProjectType === ArtifactProjectType.LDPlus &&
              context.capabilities?.includes(
                LutronDesignerMessageType.MigrateToAthenaRequest,
              ))) && <ArtifactKebabMenu artifact={artifact} />}
        </>
      </DesignTableCell>
      <DesignTableCell hideColumn>{artifact.modifiedBy || "-"}</DesignTableCell>
      <DesignTableCell>{dateFormat(artifact.modifiedDate)}</DesignTableCell>
    </DesignTableRow>
  );
};

export default DesignRow;
